import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["pagesWrapper", "breadcrumbs"];
    static values = { language: String, strings: Object };

    connect() {
        this.history = [];
        this.renderBreadcrumbs();

        const myWielandMenuCache = localStorage.getItem('myWielandMenuCache');
        if (myWielandMenuCache) {
            const rawItems = JSON.parse(myWielandMenuCache);
            const groupedCategories = this.groupByCategory(rawItems);

            const language = this.hasLanguageValue ? this.languageValue : "en";

            this.appendMyWielandMenu(groupedCategories, language);
        }
    }

    appendMyWielandMenu(groupedCategories, language) {

        const firstLevelMenu = this.pagesWrapperTarget.querySelector(
            '.mobile-menu-page[data-menu-level="1"] .mobile-menu-list'
        );
        if (!firstLevelMenu) return;

        const parentId = "mywieland-root";

        const li = document.createElement('li');
        li.classList.add('menu-item');
        li.dataset.categoryId = parentId;

        const div = document.createElement('div');
        div.classList.add(
            'menu-item-title',
            'd-flex',
            'justify-content-between',
            'align-items-center'
        );
        div.dataset.action = "click->mobile-menu#toggle";
        div.dataset.categoryId = parentId;
        div.dataset.level = "1";

        const span = document.createElement('span');
        span.textContent = "myWieland";
        div.appendChild(span);

        const chevron = document.createElement('i');
        chevron.classList.add('fal', 'fa-chevron-right');
        div.appendChild(chevron);

        li.appendChild(div);
        firstLevelMenu.appendChild(li);

        this.renderChildMenu(groupedCategories, 2, parentId, language);
    }


    renderChildMenu(children, level, parentId, language) {
        const container = document.createElement('div');
        container.classList.add('mobile-menu-page');
        container.dataset.menuLevel = level;
        container.dataset.parentId = parentId;
        container.style.display = 'none';

        const ul = document.createElement('ul');
        ul.classList.add('mobile-menu-list');

        children.forEach(child => {
            const li = document.createElement('li');
            li.classList.add('menu-item');
            li.dataset.categoryId = child.id;

            const div = document.createElement('div');
            div.classList.add('menu-item-title', 'd-flex', 'justify-content-between', 'align-items-center');
            div.dataset.action = "click->mobile-menu#toggle";
            div.dataset.categoryId = child.id;
            div.dataset.level = level.toString();

            const titleSpan = document.createElement('span');
            if (child.url) {
                const a = document.createElement('a');
                a.href = `/${language}/mywieland/${child.url}`;
                a.textContent = child.name;
                titleSpan.appendChild(a);
            } else {
                titleSpan.textContent = child.name;
            }
            div.appendChild(titleSpan);

            if (child.children && child.children.length) {
                const chevron = document.createElement('i');
                chevron.classList.add('fal', 'fa-chevron-right');
                div.appendChild(chevron);
            }

            li.appendChild(div);
            ul.appendChild(li);

            if (child.children && child.children.length) {
                this.renderChildMenu(child.children, level + 1, child.id, language);
            }
        });

        container.appendChild(ul);
        this.pagesWrapperTarget.appendChild(container);
    }


    groupByCategory(items) {
        const grouped = {};
        items.forEach(item => {
            if (!grouped[item.category]) {
                grouped[item.category] = {
                    id: `category-${item.category}`,
                    name: item.category.charAt(0).toUpperCase() + item.category.slice(1),
                    children: []
                };
            }
            grouped[item.category].children.push({
                id: item.url || item.name.toLowerCase().replace(/\s+/g, '-'),
                name: item.name,
                url: item.url,
                children: []
            });
        });

        return Object.values(grouped);
    }


    toggle(event) {
        const categoryId = event.currentTarget.dataset.categoryId;
        const level = parseInt(event.currentTarget.dataset.level, 10);
        const nextLevel = level + 1;

        const nextPage = this.pagesWrapperTarget.querySelector(
            `[data-parent-id="${categoryId}"][data-menu-level="${nextLevel}"]`
        );

        if (!nextPage) return;

        this.showPage(nextPage);

        const overviewLi = this.pagesWrapperTarget.querySelector(
            `li.menu-item.menu-item-overview-mobile.d-none[data-category-id="${categoryId}"]`
        );
        if (overviewLi) {
            overviewLi.classList.remove('d-none');
        }

        this.history.push({
            id: categoryId,
            level: nextLevel,
            name: event.currentTarget.querySelector("span, a").textContent.trim()
        });

        this.renderBreadcrumbs();
    }

    showPage(pageToShow) {
        const allPages = this.pagesWrapperTarget.querySelectorAll(".mobile-menu-page");
        allPages.forEach(page => page.style.display = "none");
        pageToShow.style.display = "block";
    }

    goBack(event) {
        event.preventDefault();
        this.history.pop();

        const last = this.history[this.history.length - 1];

        if (last) {
            const parentLi = this.pagesWrapperTarget.querySelector(`li.menu-item.menu-item-overview-mobile[data-category-id="${last.id}"]`);
            if (parentLi) {
                parentLi.classList.add('d-none');
            }
        }

        if (!last) {
            const firstPage = this.pagesWrapperTarget.querySelector('[data-menu-level="1"]');
            this.showPage(firstPage);
        } else {
            const prevPage = this.pagesWrapperTarget.querySelector(
                `[data-parent-id="${last.id}"][data-menu-level="${last.level}"]`
            );
            if (prevPage) {
                this.showPage(prevPage);
            }
        }

        this.renderBreadcrumbs();
    }

    renderBreadcrumbs() {
        if (this.history.length === 0) {
            this.breadcrumbsTarget.innerHTML = `<span class="mobile-menu-title">Menu</span>`;
            return;
        }

        const previous = this.history[this.history.length - 1];

        this.breadcrumbsTarget.innerHTML = `
            <div 
                class="mobile-back-wrapper"
                data-action="click->mobile-menu#goBack"
                role="button"
                tabindex="0"
            >
                <i class="fal fa-chevron-left mobile-back-icon me-2"></i>
                <span class="mobile-back-label">${previous.name}</span>
            </div>
            `;
        this.breadcrumbsTarget.style.display = "flex";
    }
}
